import Immutable from 'immutable';

// constants
import {
  APPOINTMENT_CANCEL
} from '../constants/appointmentTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { APPOINTMENT_STATUS_CLEAR } from '../constants/appointmentStatusTypes';

const showDirectOfficeContactModal = function(map, action) {
  if (action.payload.closeToStart) {
    map.set('closeToStart', true);
  }
  return map;
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case APPOINTMENT_CANCEL:                      return httpReducer(state, action, showDirectOfficeContactModal);
    case APPOINTMENT_STATUS_CLEAR:                return Immutable.Map();
    default:                                      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/appointmentStatus.js